var viActivity = {
  translation: {
    activity: {
      all: 'Tất cả',
      apiClientCreate:
        'Đã tạo API client <name>{{name}}</name> với các quyền: <permissions>{{permissions}}</permissions>',
      apiClientDelete: 'Đã xóa API client <name>{{name}}</name>',
      apiClientUpdate:
        'Đã cập nhật API client <prevName>{{prevName}}</prevName> -> <name>{{name}}</name>, quyền mới <permissions>{{permissions}}</permissions>, đã tái tạo secret: <regenerateSecret>{{regenerateSecret}}</regenerateSecret>',
      attachment: 'Tệp đính kèm',
      attachmentShort: 'Đ.kèm.',
      board: 'Bảng',
      boardAddedGithubRepo:
        'Đã thêm kho GitHub <githubRepo>{{githubRepo}}</githubRepo> vào bảng <board>{{board}}</board>',
      boardAddedGithubRepoShort:
        'Đã thêm kho GitHub <githubRepo>{{githubRepo}}</githubRepo> vào bảng này',
      boardCreate:
        'Đã tạo bảng <board>{{board}}</board> (đã nhập: <isImportedBoard>{{isImportedBoard}}</isImportedBoard>) trong <project>{{project}}</project>',
      boardCreateShort:
        'Đã tạo bảng này (đã nhập: <isImportedBoard>{{isImportedBoard}}</isImportedBoard>) trong <project>{{project}}</project>',
      boardDelete:
        'Đã xóa bảng <board>{{board}}</board> khỏi <project>{{project}}</project>',
      boardDeleteShort: 'Đã xóa bảng này khỏi <project>{{project}}</project>',
      boardRemovedGithubRepo:
        'Đã gỡ kho GitHub <githubRepo>{{githubRepo}}</githubRepo> khỏi bảng <board>{{board}}</board>',
      boardRemovedGithubRepoShort:
        'Đã gỡ kho GitHub <githubRepo>{{githubRepo}}</githubRepo> khỏi bảng này',
      boardShort: 'Bảng',
      boardTemplateCreate: 'Đã tạo mẫu bảng <name>{{name}}</name>',
      boardTemplateCreateGlobal: 'Đã tạo mẫu bảng toàn cục <name>{{name}}</name>',
      boardTemplateDelete: 'Đã xóa mẫu bảng <name>{{name}}</name>',
      boardTemplateDeleteGlobal: 'Đã xóa mẫu bảng toàn cục <name>{{name}}</name>',
      boardTemplateUpdate:
        'Đã cập nhật mẫu bảng <prevName>{{prevName}}</prevName> thành <name>{{name}}</name>',
      boardTemplateUpdateGlobal:
        'Đã cập nhật mẫu bảng toàn cục <prevName>{{prevName}}</prevName> thành <name>{{name}}</name>',
      boardTemplateUpdateToGlobal:
        'Đã cập nhật phạm vi mẫu bảng <name>{{name}}</name> thành toàn cục',
      boardTemplateUpdateToUser:
        'Đã cập nhật phạm vi mẫu bảng <name>{{name}}</name> thành người dùng',
      boardUpdateGithubRepo:
        'Đã cập nhật kho GitHub của bảng <board>{{board}}</board> từ <prevGithubRepo>{{prevGithubRepo}}</prevGithubRepo> sang <githubRepo>{{githubRepo}}</githubRepo>',
      boardUpdateGithubRepoShort:
        'Đã cập nhật kho GitHub của bảng này từ <prevGithubRepo>{{prevGithubRepo}}</prevGithubRepo> sang <githubRepo>{{githubRepo}}</githubRepo>',
      boardUpdateName:
        'Đã cập nhật bảng <prevBoard>{{prevBoard}}</prevBoard> thành <board>{{board}}</board>',
      boardUpdateNameShort:
        'Đã cập nhật bảng <prevBoard>{{prevBoard}}</prevBoard> thành <board>{{board}}</board>',
      boardUpdatePosition:
        'Đã cập nhật vị trí bảng <board>{{board}}</board> trong <project>{{project}}</project>',
      boardUpdatePositionShort:
        'Đã cập nhật vị trí bảng này trong <project>{{project}}</project>',
      boardUserAdd:
        'Đã thêm <user>{{user}}</user> vào bảng <board>{{board}}</board> với vai trò <role>{{role}}</role> (được bình luận: <canComment>{{canComment}}</canComment>)',
      boardUserAddShort:
        'Đã thêm <user>{{user}}</user> vào bảng này với vai trò <role>{{role}}</role> (được bình luận: <canComment>{{canComment}}</canComment>)',
      boardUserRemove:
        'Đã gỡ <user>{{user}}</user> khỏi bảng <board>{{board}}</board>',
      boardUserRemoveShort: 'Đã gỡ <user>{{user}}</user> khỏi bảng này',
      boardUserUpdateCanComment:
        'Đã cập nhật quyền bình luận của <user>{{user}}</user> thành <canComment>{{canComment}}</canComment> trong bảng <board>{{board}}</board>',
      boardUserUpdateCanCommentShort:
        'Đã cập nhật quyền bình luận của <user>{{user}}</user> thành <canComment>{{canComment}}</canComment> trong bảng này',
      boardUserUpdateRole:
        'Đã cập nhật vai trò của <user>{{user}}</user> từ <prevRole>{{prevRole}}</prevRole> (được bình luận: <prevCanComment>{{prevCanComment}}</prevCanComment>) sang <role>{{role}}</role> (được bình luận: <canComment>{{canComment}}</canComment>) trong bảng <board>{{board}}</board>',
      boardUserUpdateRoleShort:
        'Đã cập nhật vai trò của <user>{{user}}</user> từ <prevRole>{{prevRole}}</prevRole> (được bình luận: <prevCanComment>{{prevCanComment}}</prevCanComment>) sang <role>{{role}}</role> (được bình luận: <canComment>{{canComment}}</canComment>) trong bảng này',
      card: 'Thẻ',
      cardAttachmentCreate:
        'Đã thêm tệp đính kèm <attachment>{{attachment}}</attachment> vào <card>{{card}}</card>',
      cardAttachmentCreateShort:
        'Đã thêm tệp đính kèm <attachment>{{attachment}}</attachment>',
      cardAttachmentDelete:
        'Đã xóa tệp đính kèm <attachment>{{attachment}}</attachment> khỏi <card>{{card}}</card>',
      cardAttachmentDeleteShort:
        'Đã xóa tệp đính kèm <attachment>{{attachment}}</attachment>',
      cardAttachmentUpdate:
        'Đã đổi tên tệp đính kèm <prevAttachment>{{prevAttachment}}</prevAttachment> thành <attachment>{{attachment}}</attachment> trong <card>{{card}}</card>',
      cardAttachmentUpdateShort:
        'Đã đổi tên tệp đính kèm <prevAttachment>{{prevAttachment}}</prevAttachment> thành <attachment>{{attachment}}</attachment>',
      cardCommentCreate:
        'Đã thêm bình luận <comment>{{comment}}</comment> vào <card>{{card}}</card>',
      cardCommentCreateShort: 'Đã thêm bình luận <comment>{{comment}}</comment>',
      cardCommentDelete:
        'Đã xóa bình luận <comment>{{comment}}</comment> của <user>{{user}}</user> khỏi <card>{{card}}</card>',
      cardCommentDeleteShort:
        'Đã xóa bình luận <comment>{{comment}}</comment> của <user>{{user}}</user>',
      cardCommentUpdate:
        'Đã cập nhật bình luận <prevComment>{{prevComment}}</prevComment> thành <comment>{{comment}}</comment> (tác giả: <user>{{user}}</user>) trong <card>{{card}}</card>',
      cardCommentUpdateOwn:
        'Đã cập nhật bình luận của chính mình <prevComment>{{prevComment}}</prevComment> thành <comment>{{comment}}</comment> trong <card>{{card}}</card>',
      cardCommentUpdateOwnShort:
        'Đã cập nhật bình luận của chính mình <prevComment>{{prevComment}}</prevComment> thành <comment>{{comment}}</comment>',
      cardCommentUpdateShort:
        'Đã cập nhật bình luận <prevComment>{{prevComment}}</prevComment> thành <comment>{{comment}}</comment> (tác giả: <user>{{user}}</user>)',
      cardCreate:
        'Đã tạo <card>{{card}}</card> trong <list>{{list}}</list> {{viaApi}}',
      cardCreateShort:
        'Đã tạo thẻ này trong <list>{{list}}</list> {{viaApi}}',
      cardDelete: 'Đã xóa <card>{{card}}</card> khỏi <list>{{list}}</list>',
      cardDeleteShort: 'Đã xóa thẻ này khỏi <list>{{list}}</list>',
      cardDuplicate: 'Đã nhân bản <card>{{card}}</card> trong <list>{{list}}</list>',
      cardDuplicateShort: 'Đã nhân bản thẻ này trong <list>{{list}}</list>',
      cardLabelAdd:
        'Đã thêm nhãn <label>{{label}}</label> vào <card>{{card}}</card>',
      cardLabelAddShort: 'Đã thêm nhãn <label>{{label}}</label>',
      cardLabelRemove:
        'Đã gỡ nhãn <label>{{label}}</label> khỏi <card>{{card}}</card>',
      cardLabelRemoveShort: 'Đã gỡ nhãn <label>{{label}}</label>',
      cardMove:
        'Đã chuyển <card>{{card}}</card> từ <fromList>{{fromList}}</fromList> sang <toList>{{toList}}</toList>',
      cardMoveShort:
        'Đã chuyển thẻ này từ <fromList>{{fromList}}</fromList> sang <toList>{{toList}}</toList>',
      cardShort: 'Thẻ',
      cardTaskCompleted: 'đã hoàn thành',
      cardTaskCreate:
        'Đã tạo công việc <task>{{task}}</task> trong <card>{{card}}</card>',
      cardTaskCreateShort: 'Đã tạo công việc <task>{{task}}</task>',
      cardTaskDelete:
        'Đã xóa công việc <task>{{task}}</task> khỏi <card>{{card}}</card>',
      cardTaskDeleteShort: 'Đã xóa công việc <task>{{task}}</task>',
      cardTaskDuplicate:
        'Đã nhân bản công việc <task>{{task}}</task> trong <card>{{card}}</card>',
      cardTaskDuplicateShort: 'Đã nhân bản công việc <task>{{task}}</task>',
      cardTaskMove:
        'Đã cập nhật vị trí công việc <task>{{task}}</task> trong <card>{{card}}</card>',
      cardTaskMoveShort: 'Đã cập nhật vị trí công việc <task>{{task}}</task>',
      cardTaskUncompleted: 'chưa hoàn thành',
      cardTaskUpdateDueDate:
        'Đã cập nhật hạn chót từ <prevDueDate>{{prevDueDate}}</prevDueDate> sang <dueDate>{{dueDate}}</dueDate> cho công việc <task>{{task}}</task> trong <card>{{card}}</card>',
      cardTaskUpdateDueDateAdd:
        'Đã thêm hạn chót <dueDate>{{dueDate}}</dueDate> cho công việc <task>{{task}}</task> trong <card>{{card}}</card>',
      cardTaskUpdateDueDateAddShort:
        'Đã thêm hạn chót <dueDate>{{dueDate}}</dueDate> cho công việc <task>{{task}}</task>',
      cardTaskUpdateDueDateRemove:
        'Đã gỡ hạn chót khỏi công việc <task>{{task}}</task> trong <card>{{card}}</card>',
      cardTaskUpdateDueDateRemoveShort:
        'Đã gỡ hạn chót khỏi công việc <task>{{task}}</task>',
      cardTaskUpdateDueDateShort:
        'Đã cập nhật hạn chót từ <prevDueDate>{{prevDueDate}}</prevDueDate> sang <dueDate>{{dueDate}}</dueDate> cho công việc <task>{{task}}</task> ',
      cardTaskUpdateIsCompleted:
        'Đã đánh dấu công việc <task>{{task}}</task> là <isCompleted>{{isCompleted}}</isCompleted> trong <card>{{card}}</card>',
      cardTaskUpdateIsCompletedShort:
        'Đã đánh dấu công việc <task>{{task}}</task> là <isCompleted>{{isCompleted}}</isCompleted>',
      cardTaskUpdateName:
        'Đã cập nhật công việc <prevTask>{{prevTask}}</prevTask> thành <task>{{task}}</task> trong <card>{{card}}</card>',
      cardTaskUpdateNameShort:
        'Đã cập nhật công việc <prevTask>{{prevTask}}</prevTask> thành <task>{{task}}</task>',
      cardTaskUserAdd:
        'Đã thêm người dùng <user>{{user}}</user> vào công việc <task>{{task}}</task> trong <card>{{card}}</card>',
      cardTaskUserAddShort:
        'Đã thêm người dùng <user>{{user}}</user> vào công việc <task>{{task}}</task>',
      cardTaskUserRemove:
        'Đã gỡ người dùng <user>{{user}}</user> khỏi công việc <task>{{task}}</task> trong <card>{{card}}</card>',
      cardTaskUserRemoveShort:
        'Đã gỡ người dùng <user>{{user}}</user> khỏi công việc <task>{{task}}</task>',
      cardTransferBoard:
        'Đã chuyển <card>{{card}}</card> trong cùng dự án từ <fromList>{{fromList}}</fromList> trong <fromBoard>{{fromBoard}}</fromBoard> (<fromProject>{{fromProject}}</fromProject>) sang <toList>{{toList}}</toList> trong <toBoard>{{toBoard}}</toBoard> (<toProject>{{toProject}}</toProject>)',
      cardTransferBoardShort:
        'Đã chuyển thẻ này trong cùng dự án từ <fromList>{{fromList}}</fromList> trong <fromBoard>{{fromBoard}}</fromBoard> (<fromProject>{{fromProject}}</fromProject>) sang <toList>{{toList}}</toList> trong <toBoard>{{toBoard}}</toBoard> (<toProject>{{toProject}}</toProject>)',
      cardTransferProject:
        'Đã chuyển <card>{{card}}</card> từ <fromList>{{fromList}}</fromList> trong <fromBoard>{{fromBoard}}</fromBoard> (<fromProject>{{fromProject}}</fromProject>) sang <toList>{{toList}}</toList> trong <toBoard>{{toBoard}}</toBoard> (<toProject>{{toProject}}</toProject>)',
      cardTransferProjectShort:
        'Đã chuyển thẻ này từ <fromList>{{fromList}}</fromList> trong <fromBoard>{{fromBoard}}</fromBoard> (<fromProject>{{fromProject}}</fromProject>) sang <toList>{{toList}}</toList> trong <toBoard>{{toBoard}}</toBoard> (<toProject>{{toProject}}</toProject>)',
      cardUpdateCoverAttachment:
        'Đã cập nhật tệp ảnh bìa từ <prevCoverAttachment>{{prevCoverAttachment}}</prevCoverAttachment> sang <coverAttachment>{{coverAttachment}}</coverAttachment> trong <card>{{card}}</card>',
      cardUpdateCoverAttachmentAdd:
        'Đã thêm tệp ảnh bìa <coverAttachment>{{coverAttachment}}</coverAttachment> vào <card>{{card}}</card>',
      cardUpdateCoverAttachmentAddShort:
        'Đã thêm tệp ảnh bìa <coverAttachment>{{coverAttachment}}</coverAttachment> vào thẻ này',
      cardUpdateCoverAttachmentRemove:
        'Đã gỡ tệp ảnh bìa <prevCoverAttachment>{{prevCoverAttachment}}</prevCoverAttachment> khỏi <card>{{card}}</card>',
      cardUpdateCoverAttachmentRemoveShort:
        'Đã gỡ tệp ảnh bìa <prevCoverAttachment>{{prevCoverAttachment}}</prevCoverAttachment> khỏi thẻ này',
      cardUpdateCoverAttachmentShort:
        'Đã cập nhật tệp ảnh bìa từ <prevCoverAttachment>{{prevCoverAttachment}}</prevCoverAttachment> sang <coverAttachment>{{coverAttachment}}</coverAttachment>',
      cardUpdateDescription:
        'Đã cập nhật mô tả từ <prevDescription>{{prevDescription}}</prevDescription> sang <description>{{description}}</description> của <card>{{card}}</card>',
      cardUpdateDescriptionAdd:
        'Đã thêm mô tả <description>{{description}}</description> vào <card>{{card}}</card>',
      cardUpdateDescriptionAddShort:
        'Đã thêm mô tả <description>{{description}}</description> vào thẻ này',
      cardUpdateDescriptionRemove:
        'Đã gỡ mô tả <prevDescription>{{prevDescription}}</prevDescription> khỏi <card>{{card}}</card>',
      cardUpdateDescriptionRemoveShort:
        'Đã gỡ mô tả <prevDescription>{{prevDescription}}</prevDescription> khỏi thẻ này',
      cardUpdateDescriptionShort:
        'Đã cập nhật mô tả từ <prevDescription>{{prevDescription}}</prevDescription> sang <description>{{description}}</description>',
      cardUpdateDueDate:
        'Đã cập nhật hạn chót từ <prevDueDate>{{prevDueDate}}</prevDueDate> sang <dueDate>{{dueDate}}</dueDate> của <card>{{card}}</card>',
      cardUpdateDueDateAdd:
        'Đã thêm hạn chót <dueDate>{{dueDate}}</dueDate> vào <card>{{card}}</card>',
      cardUpdateDueDateAddShort:
        'Đã thêm hạn chót <dueDate>{{dueDate}}</dueDate> vào thẻ này',
      cardUpdateDueDateRemove: 'Đã gỡ hạn chót khỏi <card>{{card}}</card>',
      cardUpdateDueDateRemoveShort: 'Đã gỡ hạn chót khỏi thẻ này',
      cardUpdateDueDateShort:
        'Đã cập nhật hạn chót từ <prevDueDate>{{prevDueDate}}</prevDueDate> sang <dueDate>{{dueDate}}</dueDate>',
      cardUpdateName:
        'Đã cập nhật <prevCard>{{prevCard}}</prevCard> thành <card>{{card}}</card>',
      cardUpdateNameShort:
        'Đã cập nhật <prevCard>{{prevCard}}</prevCard> thành <card>{{card}}</card>',
      cardUpdatePosition:
        'Đã cập nhật vị trí <card>{{card}}</card> trong <list>{{list}}</list>',
      cardUpdatePositionShort: 'Đã cập nhật vị trí thẻ trong <list>{{list}}</list>',
      cardUpdateTimerAdd:
        'Đã bắt đầu bấm giờ <timer>{{timer}}</timer> trên <card>{{card}}</card>',
      cardUpdateTimerAddShort:
        'Đã bắt đầu bấm giờ <timer>{{timer}}</timer> trên thẻ này',
      cardUpdateTimerEdit:
        'Đã sửa bấm giờ từ <prevTimer>{{prevTimer}}</prevTimer> thành <timer>{{timer}}</timer> trên <card>{{card}}</card>',
      cardUpdateTimerEditShort:
        'Đã sửa bấm giờ từ <prevTimer>{{prevTimer}}</prevTimer> thành <timer>{{timer}}</timer> trên thẻ này',
      cardUpdateTimerRemove:
        'Đã gỡ bấm giờ <prevTimer>{{prevTimer}}</prevTimer> khỏi <card>{{card}}</card>',
      cardUpdateTimerRemoveShort:
        'Đã gỡ bấm giờ <prevTimer>{{prevTimer}}</prevTimer> khỏi thẻ này',
      cardUpdateTimerStart:
        'Đã tiếp tục bấm giờ từ <prevTimer>{{prevTimer}}</prevTimer> trên <card>{{card}}</card>',
      cardUpdateTimerStartShort:
        'Đã tiếp tục bấm giờ từ <prevTimer>{{prevTimer}}</prevTimer>',
      cardUpdateTimerStop:
        'Đã dừng bấm giờ <timer>{{timer}}</timer> từ <prevTimer>{{prevTimer}}</prevTimer> trên <card>{{card}}</card>',
      cardUpdateTimerStopShort:
        'Đã dừng bấm giờ <timer>{{timer}}</timer> từ <prevTimer>{{prevTimer}}</prevTimer>',
      cardUserAdd:
        'Đã thêm người dùng <user>{{user}}</user> vào <card>{{card}}</card>',
      cardUserAddShort:
        'Đã thêm người dùng <user>{{user}}</user> vào thẻ này',
      cardUserRemove:
        'Đã gỡ người dùng <user>{{user}}</user> khỏi <card>{{card}}</card>',
      cardUserRemoveShort:
        'Đã gỡ người dùng <user>{{user}}</user> khỏi thẻ này',
      comment: 'Bình luận',
      commentShort: 'Bình luận',
      delete: 'Xóa',
      deletedBoard: 'Bảng đã xóa hoặc không khả dụng:\n{{board}}',
      deletedCard: 'Thẻ đã xóa hoặc không khả dụng:\n{{card}}',
      deletedProject: 'Dự án đã xóa hoặc không khả dụng:\n{{project}}',
      instance: 'Phiên bản triển khai',
      instanceShort: 'Phiên bản',
      instanceUpdateSettings:
        'Đã cập nhật cài đặt phiên bản: <settings>{{settings}}</settings>',
      labelCreate:
        'Đã tạo nhãn <label>{{label}}</label> trong <board>{{board}}</board>',
      labelCreateShort: 'Đã tạo nhãn này trong <board>{{board}}</board>',
      labelDelete:
        'Đã xóa nhãn <label>{{label}}</label> khỏi <board>{{board}}</board>',
      labelDeleteShort: 'Đã xóa nhãn khỏi <board>{{board}}</board>',
      labelUpdateColor:
        'Đã cập nhật màu của nhãn <prevLabel>{{prevLabel}}</prevLabel> thành <label>{{label}}</label> trong <board>{{board}}</board>',
      labelUpdateColorShort:
        'Đã cập nhật màu nhãn này thành <label>{{label}}</label>',
      labelUpdateName:
        'Đã cập nhật nhãn <prevLabel>{{prevLabel}}</prevLabel> thành <label>{{label}}</label> trong <board>{{board}}</board>',
      labelUpdateNameShort:
        'Đã cập nhật nhãn <prevLabel>{{prevLabel}}</prevLabel> thành <label>{{label}}</label>',
      list: 'Danh sách',
      listCollapse: 'Đã thu gọn danh sách <list>{{list}}</list>',
      listCollapseShort: 'Đã thu gọn danh sách này',
      listCreate:
        'Đã tạo danh sách <list>{{list}}</list> trong <board>{{board}}</board>',
      listCreateShort: 'Đã tạo danh sách này trong <board>{{board}}</board>',
      listDelete:
        'Đã xóa danh sách <list>{{list}}</list> khỏi <board>{{board}}</board>',
      listDeleteShort: 'Đã xóa danh sách này khỏi <board>{{board}}</board>',
      listExpand: 'Đã mở rộng danh sách <list>{{list}}</list>',
      listExpandShort: 'Đã mở rộng danh sách này',
      listShort: 'Danh sách',
      listUpdateName:
        'Đã cập nhật tên danh sách <prevList>{{prevList}}</prevList> thành <list>{{list}}</list>',
      listUpdateNameShort:
        'Đã cập nhật tên danh sách <prevList>{{prevList}}</prevList> thành <list>{{list}}</list>',
      listUpdatePosition:
        'Đã cập nhật vị trí danh sách <list>{{list}}</list> trong <board>{{board}}</board>',
      listUpdatePositionShort:
        'Đã cập nhật vị trí danh sách này trong <board>{{board}}</board>',
      mailTokenBoardCreate:
        'Đã tạo token email cho bảng <board>{{board}}</board>',
      mailTokenBoardCreateShort: 'Đã tạo token email cho bảng này',
      mailTokenBoardDelete:
        "Đã xóa token email của <user>{{user}}</user> cho bảng <board>{{board}}</board>",
      mailTokenBoardDeleteOwn:
        'Đã xóa token email của bạn cho bảng <board>{{board}}</board>',
      mailTokenBoardDeleteOwnShort:
        'Đã xóa token email của bạn cho bảng này',
      mailTokenBoardDeleteShort:
        "Đã xóa token email của <user>{{user}}</user> cho bảng này",
      mailTokenBoardUpdate:
        'Đã cập nhật token email của bạn cho bảng <board>{{board}}</board>',
      mailTokenBoardUpdateShort: 'Đã cập nhật token email của bạn cho bảng này',
      mailTokenListCreate:
        'Đã tạo token email cho danh sách <list>{{list}}</list> trong bảng <board>{{board}}</board>',
      mailTokenListCreateShort: 'Đã tạo token email cho danh sách này',
      mailTokenListDelete:
        "Đã xóa token email của <user>{{user}}</user> cho danh sách <list>{{list}}</list> trong bảng <board>{{board}}</board>",
      mailTokenListDeleteOwn:
        'Đã xóa token email của bạn cho danh sách <list>{{list}}</list> trong bảng <board>{{board}}</board>',
      mailTokenListDeleteOwnShort:
        'Đã xóa token email của bạn cho danh sách này',
      mailTokenListDeleteShort:
        "Đã xóa token email của <user>{{user}}</user> cho danh sách này",
      mailTokenListUpdate:
        'Đã cập nhật token email của bạn cho danh sách <list>{{list}}</list> trong bảng <board>{{board}}</board>',
      mailTokenListUpdateShort:
        'Đã cập nhật token email của bạn cho danh sách này',
      markAsRead: 'Đánh dấu đã đọc',
      markAsUnread: 'Đánh dấu chưa đọc',
      no: 'không',
      noBoardAvailable: 'Không có bảng',
      none: 'không có',
      noProjectAvailable: 'Không có dự án',
      project: 'Dự án',
      projectBackgroundAdd:
        'Đã thêm nền vào dự án <project>{{project}}</project>',
      projectBackgroundAddShort: 'Đã thêm nền vào dự án này',
      projectBackgroundRemove:
        'Đã gỡ nền khỏi dự án <project>{{project}}</project>',
      projectBackgroundRemoveShort: 'Đã gỡ nền khỏi dự án này',
      projectBackgroundUpdate:
        'Đã cập nhật nền dự án <project>{{project}}</project>',
      projectBackgroundUpdateShort: 'Đã cập nhật nền dự án này',
      projectCreate: 'Đã tạo dự án <project>{{project}}</project>',
      projectCreateShort: 'Đã tạo dự án này',
      projectDelete: 'Đã xóa dự án <project>{{project}}</project>',
      projectDeleteShort: 'Đã xóa dự án này',
      projectManagerAdd:
        'Đã thêm <user>{{user}}</user> làm quản lý dự án <project>{{project}}</project>',
      projectManagerAddShort:
        'Đã thêm <user>{{user}}</user> làm quản lý dự án này',
      projectManagerRemove:
        'Đã gỡ <user>{{user}}</user> khỏi vai trò quản lý dự án <project>{{project}}</project>',
      projectManagerRemoveShort:
        'Đã gỡ <user>{{user}}</user> khỏi vai trò quản lý dự án này',
      projectShort: 'Dự án',
      projectUpdateName:
        'Đã cập nhật dự án <prevProject>{{prevProject}}</prevProject> thành <project>{{project}}</project>',
      projectUpdateNameShort:
        'Đã cập nhật dự án <prevProject>{{prevProject}}</prevProject> thành <project>{{project}}</project>',
      task: 'Công việc',
      taskShort: 'Việc',
      unnamed: 'Chưa đặt tên',
      user: 'Người dùng',
      userCreate:
        'Đã tạo người dùng <userName>{{userName}}</userName> (<userEmail>{{userEmail}}</userEmail>) - quản trị: <isAdmin>{{isAdmin}}</isAdmin>',
      userDelete:
        'Đã xóa người dùng <userName>{{userName}}</userName> (<userEmail>{{userEmail}}</userEmail>)',
      userRegisterLocal:
        'Đã đăng ký người dùng cục bộ <userName>{{userName}}</userName> (<userEmail>{{userEmail}}</userEmail>) - quản trị: <isAdmin>{{isAdmin}}</isAdmin>',
      userRegisterOidc:
        'Đã đăng ký người dùng OIDC <userName>{{userName}}</userName> (<userEmail>{{userEmail}}</userEmail>) - quản trị: <isAdmin>{{isAdmin}}</isAdmin>',
      userShort: 'Người dùng',
      userUpdateAvatar:
        'Đã cập nhật ảnh đại diện cho người dùng <userName>{{userName}}</userName>',
      userUpdateEmail:
        'Đã cập nhật email người dùng <userName>{{userName}}</userName> từ <prevUserEmail>{{prevUserEmail}}</prevUserEmail> sang <userEmail>{{userEmail}}</userEmail>',
      userUpdateIsAdmin:
        'Đã cập nhật quyền quản trị của <userName>{{userName}}</userName> từ <prevIsAdmin>{{prevIsAdmin}}</prevIsAdmin> sang <isAdmin>{{isAdmin}}</isAdmin>',
      userUpdateIsVerified:
        'Đã xác minh người dùng <userName>{{userName}}</userName> với email <userEmail>{{userEmail}}</userEmail>',
      userUpdateName:
        'Đã cập nhật người dùng <prevUserName>{{prevUserName}}</prevUserName> thành <userName>{{userName}}</userName>',
      userUpdatePasswordChanged:
        'Đã đổi mật khẩu cho người dùng <userName>{{userName}}</userName>',
      userUpdateSsoGithubEmail:
        'Đã cập nhật email SSO GitHub của <userName>{{userName}}</userName> từ <prevSsoGithubEmail>{{prevSsoGithubEmail}}</prevSsoGithubEmail> sang <ssoGithubEmail>{{ssoGithubEmail}}</ssoGithubEmail>',
      userUpdateSsoGoogleEmail:
        'Đã cập nhật email SSO Google của <userName>{{userName}}</userName> từ <prevSsoGoogleEmail>{{prevSsoGoogleEmail}}</prevSsoGoogleEmail> sang <ssoGoogleEmail>{{ssoGoogleEmail}}</ssoGoogleEmail>',
      userUpdateSsoMicrosoftEmail:
        'Đã cập nhật email SSO Microsoft của <userName>{{userName}}</userName> từ <prevSsoMicrosoftEmail>{{prevSsoMicrosoftEmail}}</prevSsoMicrosoftEmail> sang <ssoMicrosoftEmail>{{ssoMicrosoftEmail}}</ssoMicrosoftEmail>',
      userUpdateSsoOidcEmail:
        'Đã cập nhật email SSO OIDC của <userName>{{userName}}</userName> từ <prevSsoOidcEmail>{{prevSsoOidcEmail}}</prevSsoOidcEmail> sang <ssoOidcEmail>{{ssoOidcEmail}}</ssoOidcEmail>',
      userUpdateUsername:
        'Đã cập nhật tên đăng nhập <prevUsername>{{prevUsername}}</prevUsername> thành <username>{{username}}</username>',
      viaApi: 'qua API',
      viaApiWithEmail: 'qua API với email <mail>{{mail}}</mail>',
      yes: 'có',
    },
  },
};

export { viActivity as default };
